import { XStack, styled } from 'tamagui';

export const TaxonomyBadge = styled(XStack, {
  alignItems: 'center',
  gap: '$1',
  paddingVertical: '$2',
  paddingHorizontal: '$3',
  borderRadius: '$true',
  backgroundColor: '$tertiary50',
  pressStyle: {
    backgroundColor: '$tertiary',
  },
  hoverStyle: {
    backgroundColor: '$tertiary75',
  },
});
